/* eslint-disable no-console */
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Timeouts } from 'app/shared/constants/timeout.constants';
import { RecognitionStatus } from 'app/shared/constants/user.constants';
import { DossierFlowService } from 'app/shared/service/dossier-flow.service';
import { disableF5 } from 'app/shared/util/modal.util';

const DEFAULTS = {
  timeLimit: 5,
  fullDashArray: 283
}
/**
 * Angular Component that show the expiration days remains for the pec user and invite user to
 */
@Component({
  selector: 'ap-pec-conversion-expire-adv',
  templateUrl: './pec-conversion-expire-adv.modal.component.html',
})
export class PecConversionExpireAdvisorModalComponent implements OnInit {
  @Input()
  public expireDays = 1;

  @Input()
  public urlGuide = '';

  @Input()
  public recognitionStatus = '';

  @Input()
  public territoryExpireDate = '';

  @Input()
  public dvoExpireDate = '';

  @Input()
  public twoFaEnabled = false;

  @Input()
  public TIME_LIMIT = DEFAULTS.timeLimit;

  @Input()
  public urlWebmail = '';

  @Input()
  public urlPGA = '';

  @Input()
  public salesChannel = '';

  @Input()
  public mailbox = '';

  FULL_DASH_ARRAY = DEFAULTS.fullDashArray;

  circleDasharray = '';

  timePassed = 0;

  timeLeft = this.TIME_LIMIT;

  timerInterval?: number | NodeJS.Timeout;

  constructor(
    public readonly activeModal: NgbActiveModal,
    private readonly dossierFlowService: DossierFlowService
  ) { }

  /**
   * Add event listeners to keyboard event in order to preven default behavior for F5 key
   */
  ngOnInit(): void {
    this.startTimer();

    window.addEventListener('keyup', disableF5);
    window.addEventListener('keydown', disableF5);
  }

  startTimer(): void {
    this.timerInterval = setInterval(() => {
      this.timePassed = this.timePassed += 1;
      this.timeLeft = this.TIME_LIMIT - this.timePassed;
      if (this.timeLeft === 0) {
        clearInterval(this.timerInterval as unknown as number);
      }
      this.setCircleDasharray();
    }, Timeouts.TIMEOUT_1000);
  }

  calculateTimeFraction(): number {
    const rawTimeFraction = this.timeLeft / this.TIME_LIMIT;
    return rawTimeFraction - (1 / this.TIME_LIMIT) * (1 - rawTimeFraction);
  }

  setCircleDasharray(): void {
    this.circleDasharray = (this.calculateTimeFraction() * this.FULL_DASH_ARRAY).toFixed(0);
  }

  /**
   * Redirect to ids if dossier service quesry is success,
   * otherwise display error based on the error status and sales channel
   */
  goToIds(): void {
    if (this.recognitionStatus !== RecognitionStatus.OK && this.recognitionStatus !== RecognitionStatus.IDENTIFICATION_IN_PROGRESS) {
      this.dossierFlowService.executeDossierFlow({
        mailbox: this.mailbox,
        urlPGA: this.urlPGA,
        urlWebmail: this.urlWebmail,
        salesChannel: this.salesChannel
      });
    } else {
      if (!this.twoFaEnabled) {
        this.hideAdvise();
      }
    }
  }

  /**
   * Close modal
   */
  hideAdvise(): void {
    window.removeEventListener('keyup', disableF5);
    window.removeEventListener('keydown', disableF5);
    this.activeModal.close();
  }
}
